import { UserProxy } from './../../providers/user/'
import { update as updateCurrentUser } from './../currentUser/currentUser.actions'

export const impersonate = to => dispatch => {
  const proxy = new UserProxy()

  return proxy.impersonate(to).then(({ data: user }) => {
    user.authenticated = true
    user.authenticatedAt = Date.now()
    updateCurrentUser(user)
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/adminActions/adminActions.actions.js